import axios from "axios";
import { v4 as uuidv4 } from 'uuid';
import type { InternalAxiosRequestConfig } from 'axios';
import { JwtResponse } from "./TokenService";
import { fetchJwtToken, getJwtToken } from "./TokenService";

const api = axios.create({ baseURL: '/gw/api' })

let fetchingToken:  Promise<JwtResponse> | null = null;

api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
    const requestId = uuidv4();
    config.headers = config.headers ?? {};
    config.headers["X-Request-ID"] = requestId;
    
    let token = getJwtToken();

    if (!token) {
        // if we're already fetching, reuse that promise
        fetchingToken ??= fetchJwtToken();
        // wait for it to resolve (this returns string)
        const resp = await fetchJwtToken();

        token = resp.token;
        // reset so future 401s will re‐fetch
        fetchingToken = null;
    }

    if (token) {
        // 3) mutate the headers object rather than replace it
        config.headers = config.headers ?? {};
        // this works because AxiosRequestConfig.headers is indexable by string
        (config.headers as Record<string, string>)["Authorization"] = `Bearer ${token}`;
    }

    return config;
},
    (error) => Promise.reject(error)
);

export default api;